import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { IndustryService } from 'src/app/shared/services/industry.service';
import { NotificationService } from '../../shared/services/notification.service';
import {
  IndustriesLoad,
  IndustriesLoadError,
  IndustriesLoadSuccess,
  INDUSTRIES_LOAD,
  INDUSTRIES_LOAD_ERROR,
  INDUSTRIES_LOAD_SUCCESS,
} from '../actions/industries.actions';

@Injectable()
export class IndustryEffects {
  public IndustriesLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<IndustriesLoad>(INDUSTRIES_LOAD),
      tap(() => (this.notificationService.loading = true)),
      mergeMap(() =>
        this.industryService.getAllIndustries().pipe(
          map(techs => {
            return new IndustriesLoadSuccess(techs);
          }),
          catchError(() => of(new IndustriesLoadError()))
        )
      )
    )
  );

  public industriesLoadSucces$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<IndustriesLoadSuccess>(INDUSTRIES_LOAD_SUCCESS),
        tap(() => (this.notificationService.loading = false))
      ),
    { dispatch: false }
  );

  public industriesLoadError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<IndustriesLoadError>(INDUSTRIES_LOAD_ERROR),
        tap(() => (this.notificationService.loading = false)),
        tap(() => this.notificationService.openSnackBar('error', 'COMMON.INDUSTRIES_NOT_LOADED'))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private industryService: IndustryService
  ) {}
}
